// Notification preferences API (cat-16 row 16.4, VW-BATCH-20260704-NOTIF-01).
// DB-backed per-actor rows via GET/PUT /api/workspace/notifications/preferences — NO client
// storage (VW state policy, hook-enforced; AC-8 greps). Identity is always server-derived.
// Same raw-fetch + fetchImpl-injection pattern as NotificationsPage (one data pattern per
// surface — plan-audit #10 alternative, kills the TanStack-provider break risk on the pinned spec).

export type PrefState = "on" | "off" | "digest";
export type DigestCadence = "immediate" | "15m" | "hourly" | "daily" | "weekly";
export type NotificationChannel = "in-app" | "email" | "teams";

export interface PrefCell {
  category: string;
  channel: NotificationChannel;
  state: PrefState;
  digest_cadence?: DigestCadence | null;
}

export interface NotificationSetting {
  active_window_start?: string | null;
  active_window_end?: string | null;
  timezone?: string | null;
  vacation_until?: string | null;
  urgency_bypass_allowed?: boolean | null;
}

export interface PreferencesResponse {
  matrix: PrefCell[];
  setting: NotificationSetting;
  defaults: Record<string, NotificationChannel[]>;
}

export interface PreferencesUpdate {
  matrix?: PrefCell[];
  setting?: NotificationSetting;
}

export async function getPreferences(
  fetchImpl: typeof fetch = fetch,
  apiBase = "/api/workspace",
): Promise<PreferencesResponse> {
  const res = await fetchImpl(`${apiBase.replace(/\/$/, "")}/notifications/preferences`, {
    credentials: "include",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as PreferencesResponse;
}

export async function putPreferences(
  update: PreferencesUpdate,
  fetchImpl: typeof fetch = fetch,
  apiBase = "/api/workspace",
): Promise<PreferencesResponse> {
  const res = await fetchImpl(`${apiBase.replace(/\/$/, "")}/notifications/preferences`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(update),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as PreferencesResponse;
}
